"use client";

import { useState } from "react";
import { setAdminKey } from "@/lib/admin-client";
import { Button, Card, inputClass } from "./ui";

/** 401 时的密钥输入卡片，各管理页共用 */
export function AdminKeyGate({ onUnlock }: { onUnlock: () => void }) {
  const [key, setKey] = useState("");
  const clerkEnabled = Boolean(process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY);

  if (clerkEnabled) {
    return (
      <div className="mx-auto max-w-sm px-5 py-24">
        <Card className="p-6">
          <h1 className="text-lg font-semibold">Admin session expired</h1>
          <p className="mt-2 text-[13px] text-muted">
            EasyShot Admin uses your verified Clerk account. No separate admin password is required.
          </p>
          <Button
            className="mt-4 w-full"
            onClick={() => {
              const returnTo = `${window.location.pathname}${window.location.search}`;
              window.location.assign(`/sign-in?redirect_url=${encodeURIComponent(returnTo)}`);
            }}
          >
            Sign in again
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-sm px-5 py-24">
      <Card className="p-6">
        <h1 className="text-lg font-semibold">Admin key</h1>
        <p className="mt-2 text-[13px] text-muted">
          This deployment requires the ADMIN_KEY to access the console.
        </p>
        <input
          type="password"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          className={`${inputClass} mt-4`}
          placeholder="ADMIN_KEY"
        />
        <Button
          className="mt-3 w-full"
          onClick={() => {
            setAdminKey(key);
            onUnlock();
          }}
        >
          Unlock
        </Button>
      </Card>
    </div>
  );
}
